
import $ from "jquery"

const LOADING_STATE_CLASS = "page-section--building-list--loading"


const DEFAULT_SELECTOR = {
  scope:              "html",
  page_section:       ".page-section--building-list",
  content_container:  ".page-section--building-list__entry-list-box",
}


const getContainer = (): JQuery => $(DEFAULT_SELECTOR.scope).find(DEFAULT_SELECTOR.page_section)

const showAsLoading = (is_loading: boolean): void => {
  const $page_section = getContainer()
  if (is_loading){
    $page_section.addClass(LOADING_STATE_CLASS)
  }
  else{
    $page_section.removeClass(LOADING_STATE_CLASS)
  }
}

const updateContent = (html_content: string): void => {
  const $content_container = $(DEFAULT_SELECTOR.scope).find(DEFAULT_SELECTOR.content_container)
  $content_container.html(html_content)
}

export default {
  showAsLoading,
  updateContent,
  getContainer,
}
